import { startAuthentication } from '@simplewebauthn/browser'
import { PublicKeyCredentialRequestOptionsJSON } from '@simplewebauthn/typescript-types'
import { AuthPayload } from 'helpers/types'
import utils from 'helpers/utils'
import axios from 'providers/axios'

type AuthenticationOptionsResponse = {
  options: PublicKeyCredentialRequestOptionsJSON
  userId: string
}

type VerificationResponse = AuthPayload & {
  redirectUrl: string
}

const passkey = {
  login: async (email: string): Promise<void> => {
    const { data } = await axios.post<AuthenticationOptionsResponse>('/passkey/generateAuthenticationOptions', { email })
    console.log('options', data.options)

    const authentication = await startAuthentication(data.options)
    console.log('authentication', authentication)

    const searchParams = new URLSearchParams(location.search)
    const response = await axios.post<VerificationResponse>('/passkey/verifyAuthenticationResponse', {
      authentication,
      userId: data.userId,
      redirectUrl: searchParams.get('redirectUrl'),
    })

    const { authDevice } = response.data
    utils.setChromeExtension(authDevice.deviceToken)

    window.location.href = response.data.redirectUrl
  },
}

export default passkey
